define((require) => {
    "use strict";

    var EditorActivity  = require("editor/ui/experience/editor/activity/EditorActivity"),
        _               = require("underscore");

    /**
     * An activity representing the creation of a widget.
     *
     * @class WidgetCreatedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _sceneModel: null,

        _widgetModels: null,

        _widgetModelProperties: null,

        /**
         * Constructor.
         *
         * @param  {AbstractWidgetModel|Array}  widgetModels A single instance
         *                                      of a <tt>AbstractWidgetModel</tt> or an array
         *                                      of <tt>AbstractWidgetModel</tt>'s.
         *
         * @param  {Scene} sceneModel           The associated <tt>Scene</tt> model.
         */
        constructor: function(widgetModels, sceneModel) {
            this._widgetModels = _.isArray(widgetModels) ? widgetModels : [widgetModels];
            this._sceneModel = sceneModel;
        },

        _onUndo: function() {
            _.each(this._widgetModels, function(widgetModel) {
                // We want to delete the widget by UUID because that is a more robust system
                // than deleting by model which is rather fragile.
                // This assumes that in an experience widget UUID's are unique and consistent
                this._sceneModel.deleteWidget(widgetModel, {cause: "undo"});
                this._sceneModel.deleteWidgetByID(widgetModel.get("uuid"), {cause: "undo"});
            }, this);
        },

        _onRedo: function() {
            _.each(this._widgetModels, function(widgetModel) {
                this._sceneModel.addWidget(widgetModel, {cause: "redo"});
            }, this);
        },

        dispose: function() {
            this._widgetModels = null;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/WidgetCreatedActivity.js